// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChild";

// MCMC-1834: Handling the variability loader for variant products by setting the value of customerUnitOfMeasure to be null if it's empty string
// TODO: Remove "XngRequestDataFromApi" method when do next upgrade, the insite solved the issue in v5.1.2202.464
export const XngRequestDataFromApi: typeof RequestDataFromApi = props => {
    const apiResult: any = { ...props.apiResult };
    apiResult.customerUnitOfMeasure = apiResult.customerUnitOfMeasure || null;
    props.apiResult = apiResult;
};

addToChainAfter(chain, RequestDataFromApi, XngRequestDataFromApi);
